export default function ClientTab() {
  return <div>Client Tab</div>;
}
